import { render } from "./ShippingAddressMedia.vue?vue&type=template&id=78851352&scoped=true"
import script from "./ShippingAddressMedia.vue?vue&type=script&lang=js"
export * from "./ShippingAddressMedia.vue?vue&type=script&lang=js"

import "./ShippingAddressMedia.vue?vue&type=style&index=0&id=78851352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78851352"]])

export default __exports__